import {
  actions,
  useAppBridge
} from "../../chunk-MZWTTJO7.mjs";

// src/app-bridge/next/route-propagator.tsx
import { useRouter } from "next/router.js";
import { useEffect } from "react";
var useRoutePropagator = () => {
  const { appBridge, appBridgeState } = useAppBridge();
  const router = useRouter();
  useEffect(() => {
    if (!(appBridgeState == null ? void 0 : appBridgeState.ready)) {
      return;
    }
    router.events.on("routeChangeComplete", (url) => {
      appBridge == null ? void 0 : appBridge.dispatch(
        actions.UpdateRouting({
          newRoute: url
        })
      ).catch(() => {
        console.error("Error dispatching action");
      });
    });
  }, [appBridgeState, appBridge]);
};
function RoutePropagator() {
  useRoutePropagator();
  return null;
}
export {
  RoutePropagator,
  useRoutePropagator
};
